
export class ChildrenDto{
    /*
   *
   */
    constructor(
        public id?: number,
        public type?: string
    ){}
}